<template>
  <div class="row d-flex justify-content-center my-3 mx-1">
    <div class="container-box">
      <div class="main-title">
        <strong>
          Inventario para Padres de Estudiantes que reciben Servicios de
          Educación Especial
        </strong>
      </div>
      <div class="message-content">
        <div class="mb-3">
          <strong>Estimado padre, madre o encargado:</strong>
        </div>
        <p class="message-paragraph">
          Reciba un cordial saludo. La Secretaría Asociada de Educación Especial
          se encuentra en un proceso de búsqueda de alternativas para fortalecer
          la participación de los padres en la educación de sus hijos con
          necesidades especiales. A tales efectos, estamos solicitando su
          colaboración para completar el instrumento Inventario para Padres de
          Estudiantes que Reciben Servicios de Educación Especial.
        </p>
        <p class="message-paragraph">
          Las contestaciones provistas por usted en cada una de las siguientes
          aseveraciones contribuirán a que el Departamento de Educación y la
          Secretaría Asociada de Educación Especial, el Centro de Servicios de
          Educación Especial, la región educativa, el distrito escolar y la
          escuela, fortalezcan su gestión para ayudar a los padres de
          estudiantes con necesidades especiales a mejorar su participación en
          el proceso educativo de su hijo.
        </p>
        <p class="message-paragraph">
          Algunas de las aseveraciones están relacionadas con la escuela a la
          cual asiste su hijo y otras con el distrito escolar. El análisis de
          los datos y los hallazgos del estudio, serán compartidos en todos los
          niveles del Departamento de Educación de Puerto Rico y con el
          Departamento de Educación de Estados Unidos. Sus respuestas en el
          instrumento serán mantenidas bajo estricta confidencialidad. Los
          resultados globales del estudio estarán disponibles en la Secretaría
          Asociada. No se obtendrán resultados individuales.
        </p>
        <p class="message-paragraph">
          Agradecemos que complete todo el inventario.
        </p>
      </div>
      <div class="action-content">
        <ValidationObserver ref="formValidator">
          <div class="d-flex flex-row action-content-input">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              class="flex-grow-1"
            >
              <custom-checkbox-single-option
                v-model="info.acceptTerms"
                option-text="Acepto los términos y responsabilidades"
                :error="errors[0]"
              />
            </ValidationProvider>
            <action-button
              variant="success custom-next-button"
              iright="fa fa-angle-double-right"
              @click="onContinue"
            >
              Continuar
            </action-button>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomCheckboxSingleOption from '@/components/common/CustomCheckboxSingleOption';
import { ActionButton } from '@/components/common';
import alertMixin from '@/mixin/alert.mixin';

export default {
  name: 'Tab1',
  mixins: [alertMixin],
  components: {
    CustomCheckboxSingleOption,
    ValidationProvider,
    ValidationObserver,
    ActionButton,
  },
  data: () => ({
    info: {
      acceptTerms: null,
    },
    messages: {
      '0681':
        'Para poder continuar al próximo paso es requerido aceptar. Para recibir asistencia en el proceso se puede comunicar con el centro de apoyo al número (787) 585-8855.',
    },
  }),
  methods: {
    async onContinue() {
      const isTermsAccepted = await this.$refs.formValidator.validate();
      if (isTermsAccepted) {
        this.$emit('select-tab', 2);
      } else {
        this.ShowToast('Error', this.messages['0681'], 'error');
      }
    },
  },
};
</script>

<style scoped lang="scss">
$singleOptionCustomSize: 46px;

.container-box {
  max-width: 998px;
  background: #fafafa;
  border-radius: 5px;
  opacity: 1;
  padding: 30px;

  .main-title {
    margin-bottom: 20px;
    strong {
      text-align: center;
      font: Bold 24px/29px Lato;
      letter-spacing: 0px;
      color: #11291b;
    }
  }

  .message-content {
    margin-bottom: 30px;
    .message-paragraph {
      text-align: left;
      font: Regular 16px/19px Lato;
      letter-spacing: 0px;
      color: #11291b;
    }
  }

  .action-content {
    padding: 10px;
    ::v-deep .custom-single-checkbox {
      height: $singleOptionCustomSize;
      .d-flex {
        height: $singleOptionCustomSize;
        .checkbox-container {
          min-height: $singleOptionCustomSize;
        }
        .checkbox-word-container {
          border-radius: 0px !important;
        }
        .green-box {
          height: 48px !important;
          margin-top: -1px;
        }
      }
    }
    .custom-next-button {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      height: 45px;
      margin-top: 0px;
    }
  }
}
</style>
